import { render, staticRenderFns } from "./BusinessPartnerContactInformationList.vue?vue&type=template&id=25b67d09&"
import script from "./BusinessPartnerContactInformationList.vue?vue&type=script&lang=js&"
export * from "./BusinessPartnerContactInformationList.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPartnerContactInformationList.vue?vue&type=style&index=0&id=25b67d09&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports